// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { dbHelpers } from '../../db/database';
// import { customersAPI } from '../../api/customers';
// import syncService from '../../services/syncService';
// import { usePermissions } from '../../utils/permissions';
// import { useModal } from '../../hooks/useModal';
// import { useToast } from '../../hooks/useToast';
// import Modal from '../common/Modal';
// import './CustomersList.css';

// function CustomersList() {
//   const navigate = useNavigate();
//   const [customers, setCustomers] = useState([]);
//   const [filteredCustomers, setFilteredCustomers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [syncing, setSyncing] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [deleting, setDeleting] = useState(null);

//   const { canCreate, canEdit, canDelete } = usePermissions('customers');
//   const { isOpen, modalConfig, openModal, closeModal } = useModal();
//   const toast = useToast();

//   useEffect(() => {
//     loadCustomers();
//   }, []);

//   useEffect(() => {
//     filterCustomers();
//   }, [searchTerm, customers]);

//   async function loadCustomers() {
//     setLoading(true);
//     try {
//       const custs = await dbHelpers.getCustomers();
//       setCustomers(custs);
//     } catch (error) {
//       toast.error('Failed to load customers');
//     }
//     setLoading(false);
//   }

//   function filterCustomers() {
//     if (!searchTerm) {
//       setFilteredCustomers(customers);
//       return;
//     }
//     const filtered = customers.filter(c =>
//       c.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       c.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       c.phone?.includes(searchTerm)
//     );
//     setFilteredCustomers(filtered);
//   }

//   async function handleSync() {
//     if (!navigator.onLine) {
//       toast.error('Cannot sync while offline');
//       return;
//     }
//     setSyncing(true);
//     const result = await syncService.fullSync();

//     if (result.success) {
//       await loadCustomers();
//       toast.success('✅ Sync completed! Customers loaded.');
//     } else {
//       toast.error('❌ Sync failed: ' + result.message);
//     }
//     setSyncing(false);
//   }

//   // async function performDelete(id) {
//   //   if (!canDelete) {
//   //     toast.error('You do not have permission to delete customers');
//   //     return;
//   //   }

//   //   setDeleting(id);
//   //   try {
//   //     await dbHelpers.deleteCustomer(id);

//   //     // ✅ Remove from state directly — no reload needed
//   //     setCustomers(prev => prev.filter(c => c.id !== id));
//   //     closeModal();
//   //     toast.success('✅ Customer deleted successfully');
//   //   } catch (error) {
//   //     toast.error('Failed to delete customer: ' + error.message);
//   //   } finally {
//   //     setDeleting(null);
//   //   }
//   // }

//   async function performDelete(id) {
//   setDeleting(id);
//   try {
//     if (navigator.onLine) {
//       // ✅ Delete from server first
//       await customersAPI.delete(id);
//     } else {
//       // ✅ Offline — mark for deletion, sync later
//       await dbHelpers.markForDeletion('customers', id);
//       toast.info('⚠️ Offline: Will delete from server when back online');
//     }

//     // Then remove from IndexedDB
//     await dbHelpers.deleteCustomer(id);
//     setCustomers(prev => prev.filter(c => c.id !== id));
//     closeModal();
//     toast.success('✅ Customer deleted successfully');
//   } catch (error) {
//     toast.error('Failed to delete customer: ' + error.message);
//   } finally {
//     setDeleting(null);
//   }
// }

//   function handleDelete(customer) {
//     openModal({
//       title: 'Delete Customer?',
//       message: `Are you sure you want to delete "${customer.name}"? This action cannot be undone.`,
//       type: 'danger',
//       confirmText: 'Delete Customer',
//       cancelText: 'Cancel',
//       onConfirm: () => performDelete(customer.id)
//     });
//   }

//   if (loading) {
//     return (
//       <div className="customers-list">
//         <div className="customers-header">
//           <h1>Customers</h1>
//         </div>
//         <div className="loading-state">
//           <div className="spinner"></div>
//           <p>Loading customers...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="customers-list fade-in">
//       <div className="customers-header">
//         <div>
//           <h1>Customers</h1>
//           <p className="subtitle">{customers.length} customers</p>
//         </div>
//         <div style={{ display: 'flex', gap: '12px' }}>
//           {canCreate && (
//             <button onClick={() => navigate('/customers/new')} className="btn-primary">
//               ➕ Add Customer
//             </button>
//           )}
//           <button
//             onClick={handleSync}
//             className="btn-sync"
//             disabled={syncing || !navigator.onLine}
//           >
//             {syncing ? '⟳ Syncing...' : '🔄 Sync'}
//           </button>
//         </div>
//       </div>

//       <div className="customers-controls">
//         <input
//           type="text"
//           className="search-input"
//           placeholder="🔍 Search customers..."
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
//       </div>

//       {filteredCustomers.length === 0 ? (
//         <div className="empty-state">
//           <div className="empty-icon">👥</div>
//           <p className="empty-title">No customers found</p>
//           <p className="empty-desc">
//             {customers.length === 0
//               ? 'Customers will appear here after syncing with server'
//               : 'Try adjusting your search term'}
//           </p>
//           {customers.length === 0 && navigator.onLine && canCreate && (
//             <button onClick={handleSync} className="btn-primary" style={{ marginTop: '20px' }}>
//               🔄 Sync Now
//             </button>
//           )}
//         </div>
//       ) : (
//         <div className="customers-grid">
//           {filteredCustomers.map(customer => (
//             <div key={customer.id} className="customer-card">
//               <div className="customer-header">
//                 <div className="customer-avatar">
//                   {customer.name?.substring(0, 2).toUpperCase() || 'CU'}
//                 </div>
//                 <div className="status-indicator">
//                   <span className="status-dot"></span>
//                 </div>
//               </div>

//               <div className="customer-details">
//                 <h3>{customer.name}</h3>

//                 {customer.email && (
//                   <div className="customer-info">
//                     <span className="label">📧</span>
//                     <span className="value">{customer.email}</span>
//                   </div>
//                 )}

//                 {customer.phone && (
//                   <div className="customer-info">
//                     <span className="label">📞</span>
//                     <span className="value">{customer.phone}</span>
//                   </div>
//                 )}

//                 {customer.address && (
//                   <div className="customer-info">
//                     <span className="label">📍</span>
//                     <span className="value">{customer.address}</span>
//                   </div>
//                 )}
//               </div>

//               <div className="customer-footer">
//                 {canEdit && (
//                   <button
//                     className="btn-action"
//                     onClick={() => navigate(`/customers/edit/${customer.id}`)}
//                   >
//                     Edit
//                   </button>
//                 )}

//                 {canDelete && (
//                   <button
//                     className="btn-action btn-delete"
//                     onClick={() => handleDelete(customer)}
//                     disabled={deleting === customer.id}
//                   >
//                     {deleting === customer.id ? '⏳' : 'Delete'}
//                   </button>
//                 )}

//                 {!canEdit && !canDelete && (
//                   <button
//                     className="btn-action"
//                     onClick={() => navigate(`/customers/${customer.id}`)}
//                   >
//                     View
//                   </button>
//                 )}
//               </div>
//             </div>
//           ))}
//         </div>
//       )}

//       <Modal isOpen={isOpen} onClose={closeModal} {...modalConfig} />
//     </div>
//   );
// }

// export default CustomersList;

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { dbHelpers } from '../../db/database';
import { customersAPI } from '../../api/customers';
import syncService from '../../services/syncService';
import { usePermissions } from '../../utils/permissions';
import { useModal } from '../../hooks/useModal';
import { useToast } from '../../hooks/useToast';
import Modal from '../common/Modal';
import './CustomersList.css';

function CustomersList() {
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [syncing, setSyncing] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [deleting, setDeleting] = useState(null);

  const { canCreate, canEdit, canDelete } = usePermissions('customers');
  const { isOpen, modalConfig, openModal, closeModal } = useModal();
  const toast = useToast();

  useEffect(() => {
    loadCustomers();
  }, []);

  useEffect(() => {
    filterCustomers();
  }, [searchTerm, customers]);

  async function loadCustomers() {
    setLoading(true);
    try {
      // ✅ Step 1: Show cached data instantly — no spinner if cache exists
      const cached = await dbHelpers.getCustomers();
      if (cached.length > 0) {
        setCustomers(cached);
        setLoading(false);
      }

      // ✅ Step 2: Fetch fresh from API silently in background
      if (navigator.onLine) {
        const response = await customersAPI.getAll();
        const fresh = response.data?.results || response.data || [];
        if (fresh.length > 0) {
          await dbHelpers.saveCustomers(fresh);
          setCustomers(fresh);
        }
      }
    } catch (error) {
      toast.error('Failed to load customers');
    }
    setLoading(false);
  }

  function filterCustomers() {
    if (!searchTerm) {
      setFilteredCustomers(customers);
      return;
    }
    const filtered = customers.filter(c =>
      c.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      c.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      c.phone?.includes(searchTerm)
    );
    setFilteredCustomers(filtered);
  }

  async function handleSync() {
    if (!navigator.onLine) {
      toast.error('Cannot sync while offline');
      return;
    }
    setSyncing(true);
    const result = await syncService.fullSync();
    if (result.success) {
      await loadCustomers();
      toast.success('✅ Sync completed! Customers updated.');
    } else {
      toast.error('❌ Sync failed: ' + result.message);
    }
    setSyncing(false);
  }

  async function performDelete(customer) {
    setDeleting(customer.id);
    try {
      if (navigator.onLine) {
        // ✅ Online: delete from server
        await customersAPI.delete(customer.id);
      } else {
        // ✅ Offline: queue for sync when back online
        await dbHelpers.markForDeletion('customers', customer.id);
        toast.info('⚠️ Offline: Will delete from server when back online');
      }

      // Always remove from local DB and UI immediately
      await dbHelpers.deleteCustomer(customer.id);
      setCustomers(prev => prev.filter(c => c.id !== customer.id));
      closeModal();
      toast.success('✅ Customer deleted successfully');
    } catch (error) {
      toast.error('Failed to delete customer: ' + error.message);
    } finally {
      setDeleting(null);
    }
  }

  function handleDelete(customer) {
    openModal({
      title: 'Delete Customer?',
      message: `Are you sure you want to delete "${customer.name}"? This action cannot be undone.`,
      type: 'danger',
      confirmText: 'Delete Customer',
      cancelText: 'Cancel',
      onConfirm: () => performDelete(customer)
    });
  }

  if (loading && customers.length === 0) {
    return (
      <div className="customers-list">
        <div className="customers-header"><h1>Customers</h1></div>
        <div className="loading-state">
          <div className="spinner"></div>
          <p>Loading customers...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="customers-list fade-in">
      <div className="customers-header">
        <div>
          <h1>Customers</h1>
          <p className="subtitle">{customers.length} customers</p>
        </div>
        <div style={{ display: 'flex', gap: '12px' }}>
          {canCreate && (
            <button onClick={() => navigate('/customers/new')} className="btn-primary">
              ➕ Add Customer
            </button>
          )}
          <button
            onClick={handleSync}
            className="btn-sync"
            disabled={syncing || !navigator.onLine}
          >
            {syncing ? '⟳ Syncing...' : '🔄 Sync'}
          </button>
        </div>
      </div>

      <div className="customers-controls">
        <input
          type="text"
          className="search-input"
          placeholder="🔍 Search customers..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {filteredCustomers.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">👥</div>
          <p className="empty-title">No customers found</p>
          <p className="empty-desc">
            {customers.length === 0
              ? 'Customers will appear here after syncing with server'
              : 'Try adjusting your search term'}
          </p>
          {customers.length === 0 && navigator.onLine && canCreate && (
            <button onClick={handleSync} className="btn-primary" style={{ marginTop: '20px' }}>
              🔄 Sync Now
            </button>
          )}
        </div>
      ) : (
        <div className="customers-grid">
          {filteredCustomers.map(customer => (
            <div key={customer.id} className="customer-card">
              <div className="customer-header">
                <div className="customer-avatar">
                  {customer.name?.substring(0, 2).toUpperCase() || 'CU'}
                </div>
                <div className="status-indicator">
                  <span className="status-dot"></span>
                </div>
              </div>

              <div className="customer-details">
                <h3>{customer.name}</h3>
                {customer.email && (
                  <div className="customer-info">
                    <span className="label">📧</span>
                    <span className="value">{customer.email}</span>
                  </div>
                )}
                {customer.phone && (
                  <div className="customer-info">
                    <span className="label">📞</span>
                    <span className="value">{customer.phone}</span>
                  </div>
                )}
                {customer.address && (
                  <div className="customer-info">
                    <span className="label">📍</span>
                    <span className="value">{customer.address}</span>
                  </div>
                )}
              </div>

              <div className="customer-footer">
                {canEdit && (
                  <button
                    className="btn-action"
                    onClick={() => navigate(`/customers/edit/${customer.id}`)}
                  >
                    Edit
                  </button>
                )}
                {canDelete && (
                  <button
                    className="btn-action btn-delete"
                    onClick={() => handleDelete(customer)}
                    disabled={deleting === customer.id}
                  >
                    {deleting === customer.id ? '⏳' : 'Delete'}
                  </button>
                )}
                {!canEdit && !canDelete && (
                  <button
                    className="btn-action"
                    onClick={() => navigate(`/customers/${customer.id}`)}
                  >
                    View
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      <Modal isOpen={isOpen} onClose={closeModal} {...modalConfig} />
    </div>
  );
}

export default CustomersList;